import React from "react";
import { Chip, CircularProgress } from "@mui/material";
import { TaskAlt, ErrorOutline } from "@mui/icons-material";

export default function VerifyAccountStatusChip({
  accountName,
  verifyingAccount,
  error,
}) {
  // Loading state
  if (verifyingAccount) {
    return (
      <Chip
        icon={<CircularProgress size={16} />}
        label="Verifying account..."
        variant="outlined"
        className="rounded-xl"
      />
    );
  }

  // Error state
  if (error) {
    return (
      <Chip
        icon={<ErrorOutline />}
        label={error}
        color="error"
        variant="outlined"
        className="rounded-xl"
      />
    );
  }

  // Success state
  if (accountName) {
    return (
      <Chip
        icon={<TaskAlt />}
        label={accountName}
        color="success"
        variant="outlined"
        className="rounded-xl"
      />
    );
  }

  return null; // nothing to show
}
